export default "__VITE_ASSET__9PQ4sK$c__"